// Query keys for React Query - drivers
export const driversKeys = {
  all: ["drivers"] as const,
  list: () => [...driversKeys.all, "list"] as const,
};
